import { createSelectMap, Store } from '@ngxs/store';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { EditorSettingsComponent, SidebarComponent } from './core/components';
import { AuthService, ConfigService } from './core/service';
import { AppLoadingState, CloseMenu, MenuState, OpenMenu, UserState } from './core/state';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatToolbar, MatToolbarModule } from '@angular/material/toolbar';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { LoginFormComponent } from '@akelius-edu/edu-user';
import { MatIconButton } from '@angular/material/button';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatSidenavModule,
    MatToolbarModule,
    SidebarComponent,
    RouterOutlet,
    MatProgressSpinner,
    MatToolbar,
    RouterLink,
    MatMenu,
    MatIcon,
    LoginFormComponent,
    MatMenuTrigger,
    MatIconButton,
  ],
})
export class AppComponent {
  private readonly store = inject(Store);
  private readonly dialog = inject(MatDialog);
  private readonly authService = inject(AuthService);
  private readonly configService = inject(ConfigService);
  private readonly router = inject(Router);

  protected showLogin = true;
  protected showTitle = true;

  onLoginSubmit($event) {
    this.configService.init($event.username, $event.password).subscribe({
      next: res => {
        this.showLogin = false;
        this.router.navigate(['translation-editor']);
      },
      error: (err: any) => {},
    });
  }

  selectors = createSelectMap({
    isMenuOpen: MenuState.isMenuOpen,
    isDICMember: UserState.isDICMember,
    isAppLoading: AppLoadingState.isAppLoading,
    user: UserState.user,
  });

  onMenuOpenClick(): void {
    this.store.dispatch(new OpenMenu());
  }

  onMenuClosing(): void {
    this.store.dispatch(new CloseMenu());
  }

  onLogoutClick(): void {
    //this.authService.logout();
    this.router.navigate(['../']);
    this.showLogin = true;
    localStorage.removeItem('token');
  }

  onEditorSettingsClick(): void {
    this.dialog.open(EditorSettingsComponent, {
      width: '60vw',
    });
  }

  protected readonly environment = environment;
}
